<bca-product-dialog
  (productSelected)="onProductSelected($event)"
  (closeProductDialog)="closeProductDialog()"
></bca-product-dialog>
<bca-choose-route-dialog
  (onRouteSelected)="onCloseRouteDialog()"
></bca-choose-route-dialog>
<div class="products-overview-container">
  <div>
    <div class="tile__title">
      <bca-page-header
        [isSubsequentCard]="(totalProductCount$ | async) > 0"
        (mijnNsZakelijkClick)="goToMijnNSZakelijk()"
      ></bca-page-header>
      <h2 class="nes-h4 nes-mb-3 select-product-header" style="font-size: 24px;">
        @if ((cardNumber$ | async) === 1) {
          {{ "COMPOSE.PRODUCTS_OVERVIEW.SELECT_PRODUCT_HEADER.TITLE" | translate }}
        } @else {
          {{ "COMPOSE.PRODUCTS_OVERVIEW.SELECT_PRODUCT_HEADER.TITLE_NTH" | translate: { n: (cardNumber$ | async) } }}
        }
      </h2>
      <p class="nes-mb-5 vat-text">
        {{ "RECEIPT.KEUZEHULP_PANEL.TEXT" | translate }}
        <nes-link (nesOnClick)="directToKeuzehulp()">{{ "RECEIPT.KEUZEHULP_PANEL.BUTTON" | translate }}</nes-link>
      </p>
      @if (productsLoading$ | async) {
        <div>
          <app-products-overview-skeleton />
        </div>
      } @else {
        <div class="nes-flex nes-flex-col nes-gap-5 nes-mb-8">
          @for (product of allProducts$ | async; track product.identifier) {
            @if (product.identifier === "BCB") {
              <div class="nes-h-full">
                <bca-product-card
                  [id]="product.identifier"
                  [cypress]="product.identifier"
                  [showNewProductLayout]="!showNewProductLayout"
                  [isMobileView]="mobileQueryMatches$ | async"
                  [hideSticker]="hideSticker$ | async"
                  [isSelected]="
                    (selectedProduct$ | async)?.identifier ===
                    product.identifier
                  "
                  [isPreSelected]="product | preSelected"
                  [routeLoading]="routeLoading$ | async"
                  [product]="product"
                  [configuredProduct]="
                    product.identifier === ProductIdentifier.Traject
                      ? (configuredProduct$ | async)
                      : null
                  "
                  (selected)="onProductSelected($event)"
                  (chooseRoute)="onRouteDialogOpened()"
                  (readMore)="onReadMoreOpened($event)"
                />
              </div>
            }
          }
        </div>

        <div class="nes-flex nes-flex-col nes-gap-5">
          @for (product of allProducts$ | async; track product.identifier) {
            @if (product.identifier !== "BCB") {
              <div class="nes-h-full">
                <bca-product-card
                  [id]="product.identifier"
                  [cypress]="product.identifier"
                  [showNewProductLayout]="!showNewProductLayout"
                  [isMobileView]="mobileQueryMatches$ | async"
                  [hideSticker]="hideSticker$ | async"
                  [isSelected]="
                    (selectedProduct$ | async)?.identifier ===
                    product.identifier
                  "
                  [isPreSelected]="product | preSelected"
                  [routeLoading]="routeLoading$ | async"
                  [product]="product"
                  [configuredProduct]="
                    product.identifier === ProductIdentifier.Traject
                      ? (configuredProduct$ | async)
                      : null
                  "
                  (selected)="onProductSelected($event)"
                  (chooseRoute)="onRouteDialogOpened()"
                  (readMore)="onReadMoreOpened($event)"
                />
              </div>
            }
          } @empty {
            <p></p>
          }
        </div>
      }
    </div>
  </div>
  @if (!(productsLoading$ | async)) {
    @if (selectedProduct$ | async; as product) {
      <h2 class="nes-h4 nes-mb-3 extras-header" style="font-size: 24px;">
        {{ "COMPOSE.PRODUCTS_OVERVIEW.EXTRAS_HEADER" | translate }}
      </h2>
      <bca-choose-extras
        (addProduct)="addNewProduct()"
        [selectedProduct]="product"
      />
    }
  }
  <hr class="products-overview-divider" />
  <div class="button-section">
    <div class="nes-w-full nes-flex nes-justify-start nes-items-end nes-flex-wrap button-container">
      <div class="nes-flex nes-flex-col button-inner">
        <nes-button
          variant="primary"
          icon-trailing="true"
          nes-id="to_userdata_page"
          id="to_userdata_page"
          [disabled]="routeLoading$ | async"
          (click)="nextRoute()"
        >
          {{ "COMPOSE.CONTINUE_BUTTON" | translate }}
        </nes-button>
        @if (showCtaSubText$ | async) {
          <nes-text size="sm" color="text-secondary" class="nes-mt-2">
            {{ "COMPOSE.CTA_SUB_TEXT" | translate }}
          </nes-text>
        }
      </div>
    </div>
  </div>
</div>
